/* eslint-disable react/no-unstable-nested-components */
import { Stack } from 'expo-router';
import { Platform } from 'react-native';
import { useStyles } from 'react-native-unistyles';

import BackButton from '@/components/back-button';
import { isDesktop } from '@/core';

export default function RentalTermsLayout() {
  const { theme } = useStyles();
  const hideHeader = isDesktop() && Platform.OS === 'web';

  return (
    <Stack
      screenOptions={{
        headerShown: !hideHeader,
        title: 'Rental Terms',
        headerTitle: 'Rental Terms',
        headerTitleAlign: 'center',
        headerStyle: {
          backgroundColor: theme.colors.background_1,
        },
        headerTintColor: theme.colors.text.primary,
        headerShadowVisible: false,
        headerLeft: () => <BackButton />,
      }}
    />
  );
}
